
var url = "//automotive.bulbamerica.com/related_products/getData.php";
  
function displayRelatedProducts(data, sku){
    var toAppend = "";
    toAppend += "<div class='collection-wrap clearfix'>" +
                        "<div class='collection-main'>" +
                           "<ul class='block-grid collection-th columns6'>";
      $.each(data,function(i,o){
        if(i != 0 && o.sku){
          price = o.price.split('.', 2);
          var onclick = "productClick('" + o.name + "', '" + o.sku + "', 'Related Products', '', '"+ o.price +"','Related Products - " + sku + "')";
          toAppend += 
                "<li>" +
                    "<a class='prod-th show-quick' href='" + o.link + "' title='" + o.name + "' style='height: 353px;' onclick = \"" + onclick +"\">" +
                        "<span class='thumbnail'>" +
                            "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                        "</span>" +
                        "<span class='product-title'>" + o.name + "</span>" +
                        "<span><b>SKU:</b> " + o.sku + "</span>";
                
                if(o.quantity > 0){
                    
                    toAppend += "<span class='price'><em><span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>$</span>" 
                    + price[0] 
                    + "<span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>" 
                    + price[1] + "</span>"         
                    + "</em></span>";
                }else{
                    toAppend += "<span class='price sold-out'><em>OUT OF STOCK</em></span>";
                }
                toAppend += "</a>";
                
          
          toAppend += "<div style='text-align: center' class='yotpo bottomLine'" +
                             "data-appkey='uVXPcWZp34LOwwAsoxDHWYpTYG60xu5SDOjqAks7'" +
                             "data-domain=''" +
                             "data-product-id='" + o.id + "'" +
                             "</div>";  
                toAppend += "</li>";
        }
      });
             
      $("#related_products_data").html(toAppend);
      $("#productHeader").html("Related Products");
  	  impressionsView("related", data, sku);
  }
  

